import React, { useState } from 'react';
import PropTypes from 'prop-types';

function EditModal({ recebivel, isOpen, onClose, onSave }) {
  const [editedRecebivel, setEditedRecebivel] = useState(recebivel);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedRecebivel((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSave(editedRecebivel);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="font-bold mb-4">Editar Recebível</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Descrição
          </label>
          <input
            type="text"
            name="descricao"
            value={editedRecebivel.descricao}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Valor
          </label>
          <input
            type="number"
            name="valor"
            value={editedRecebivel.valor}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Data de Recebimento
          </label>
          <input
            type="date"
            name="dataRecebimento"
            value={editedRecebivel.dataRecebimento}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}

// Definindo propTypes para validação de tipos
EditModal.propTypes = {
  recebivel: PropTypes.shape({
    descricao: PropTypes.string.isRequired,
    valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    dataRecebimento: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditModal;
